module.exports = __webpack_public_path__ + "img/members-selected.e9065ba2.svg";